import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { SignInState } from '@/store/signin/types'
import { state } from '@/store/signin/state'
import { getters } from '@/store/signin/getters'
import { mutations } from '@/store/signin/mutations'
import { actions } from '@/store/signin/actions'

export const signIn: Module<SignInState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
